import { Fragment, h } from "preact";
import { useDispatch, useSelector } from "react-redux";

import Icon from "./Icon.jsx";
import TopBarProfileMenu from "./TopBarProfileMenu.jsx";
import PageTitle from "./PageTitle.jsx";
import GlobalError from "./GlobalError.jsx";

import {
  selectCompany,
  selectCurrentUser,
  selectIsLoggedIn,
  toggleMobileMenu,
} from "../store/index";
import { classNames } from "../helpers.js";
import TopBarNotificationsMenu from "./TopBarNotificationsMenu.jsx";

export default function AppHeader(props) {
  const company = useSelector(selectCompany);
  const currentUser = useSelector(selectCurrentUser);
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const isMobileView = useSelector((state) => state.ui.isMobileView);
  const dispatch = useDispatch();
  const globalError = useSelector((state) => state.ui.globalError);

  return (
    <div class="app-header app-header--sticky">
      {globalError && <GlobalError error={globalError} />}
      <div class="app-header__topline">
        <div class="app-header__toplineInner">
          <div class="app-header__toplineLeft">
            <PageTitle class="t-h5 app-header__title" to={props.headerLink}>
              {props.title}
            </PageTitle>
          </div>

          <div class="app-header__toplineRight">
            {isMobileView ? (
              <Icon
                class="app-header__icon app-header__menuIcon"
                onClick={() => {
                  dispatch(toggleMobileMenu());
                }}
              >
                menu
              </Icon>
            ) : (
              <>
                {isLoggedIn && <TopBarNotificationsMenu user={currentUser} />}
                <TopBarProfileMenu
                  user={currentUser}
                  isLoggedIn={isLoggedIn}
                  company={company}
                />
              </>
            )}
          </div>
        </div>
      </div>
      {(props.children || props.filterBar) && (
        <div
          class={classNames(
            "app-header__secondLine",
            props.children && "app-header__secondLine--withNavi",
            props.filterBar && "app-header__secondLine--withFilters",
            props.children &&
              props.filterBar &&
              "app-header__secondLine--withBoth"
          )}
        >
          <div class="app-header__secondLineInner">
            {props.children && (
              <div class="app-header__secondNavi">{props.children}</div>
            )}
            {props.filterBar && (
              <div class="app-header__filters">{props.filterBar}</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
